import type { AnalysisGroup, AnalysisType } from "../models/analysisGroup";
import type { AnalysisMethod } from "../models/analysisMethod";
import type { IProduct } from "../models/product";
import type { IProductFamily } from "../models/productFamily";
import type { ProductPackage } from "../models/productPackage";
import { ApiBase } from "./apiBase";

class ProductsApi extends ApiBase {
  async getProductFamilies() {
    return this.get<IProductFamily[]>("animal/get_base");
  }

  async getProducts() {
    return this.get<IProduct[]>("animal/get_types");
  }

  async getAnalysisGroups() {
    return this.get<AnalysisGroup[]>("product/analysis_groups");
  }

  async getAnalysisTypes() {
    return this.get<AnalysisType[]>("product/analysis_types");
  }

  async getAnalysisMethods() {
    return this.get<AnalysisMethod[]>("product/analysis_methods");
  }

  async getProductFamilyAnalyses() {
    return this.get<{ [key: number]: AnalysisGroup[] }>(
      "journals/analysis_types",
    );
  }

  async getProductPackages() {
    return this.get<{ [key: number]: ProductPackage[] }>(
      "animal/product_packages",
    );
  }
}

export default new ProductsApi();
